import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { AlertController, ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryInterface from '../../../smoothr-web-app-core/directives/repository-directive';
import { OrderListAction } from '../../enums/OrderListAction';
import { AppComponent } from '../../app.component';
import { ModalInfoComponent } from '../modal-info/modal-info.component';
import { CheckoutModalComponent, checkoutPaymentType } from '../checkout-modal/checkout-modal.component';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import Order from '../../../smoothr-web-app-core/models/Order';
import { PromoCodeType } from '../../../smoothr-web-app-core/models/PromoCodeType';
import {
	canSkipItemModal,
	defaultsToArticleOption,
	isAvailable,
	maxFskOfOrder,
	numberD,
	numberToCurrency,
	sleep,
} from '../../../smoothr-web-app-core/utils/utils';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { NoteArticleModalComponent } from '../note-article-modal/note-article-modal.component';
import { NavigationService } from 'src/app/services/navigation.service';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { ModalInfoHalfPizzaComponent } from '../modal-info-half-pizza/modal-info-half-pizza.component';
import { environment } from 'src/environments/environment';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { InfoModalComponent } from '../info-modal/info-modal.component';
import { SelectionProductFromFreeArticleComponent } from '../selection-product-from-free-article/selection-product-from-free-article.component';
import {
	SelectionMultipleFreeArticlesComponent,
	SelectedArticleWithQuantity,
} from '../selection-multiple-free-articles/selection-multiple-free-articles.component';
import ArticleCategory from '../../../smoothr-web-app-core/models/ArticleCategory';
import { debounceTime } from 'rxjs';
import { RecomendationArticleModalComponent } from '../recomendation-article-modal/recomendation-article-modal.component';
import { CompressedStorageService } from '../../../smoothr-web-app-core/services/compression';
import { HelloAgainService } from '../../services/hello-again.service';
import { TracifyService } from '../../services/tracify.service';

@Component({
	selector: 'app-order-content',
	templateUrl: './order-content.component.html',
	styleUrls: ['order-content.component.scss'],
})
export class OrderContentComponent extends RepositoryInterface implements OnInit {
	@Output() openCheckout = new EventEmitter<void>();

	moment = moment;
	isValid = false;
	loading = false;
	ou = OrderUtils;
	pt = PreorderType;
	differenceToMvo: number;
	fromMenu = false;
	promoError: string;
	tip = 0;
	totalPriceValue = '';
	showAgeVefiried: boolean = false;
	orderFSK: number = 0;
	ageVerified: boolean = false;
	totalNumber: number = 0;
	extrasArticles: { article: Article; chosen: boolean }[] = null;
	numberToCurrency = numberToCurrency;
	public customPromoCodeRemoved = false;
	private customPromoCodeValue: PromoCode = null;
	private showCheckerDialog = false;
	private storedPromoCodes: PromoCode[] = null;
	@ViewChild('swiperSlider') swiper: ElementRef | null;
	numberD = numberD;

	public recommendationArticles: Article[] = [];

	// Relevo code properties
	public relevoCode: string = '';
	public relevoCodeError: string = '';
	private readonly RELEVO_TAG = 'relevo';

	private readonly PROMO_FOR_3_PIZZA = 'PICKUP4FOR3';
	private readonly PROMO_GELATTO_FREE = 'GELATTO_FREE';

	constructor(
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private alertCtrl: AlertController,
		private analytics: AnalyticsService,
		private navigationService: NavigationService,
		public translateService: TranslateService,
		private helloAgainService: HelloAgainService,
		private tracifyService: TracifyService
	) {
		super(repository);
		this.validate();
	}

	get hasArticles(): boolean {
		try {
			return !!this.order && !!this.order.orderedArticles && this.order.orderedArticles.length > 0;
		} catch (error) {
			console.error('Error in hasArticles getter:', error);
			return false;
		}
	}

	async ngOnInit() {
		try {
			super.ngOnInit();
			this.analytics.openOrderContent();
			if (this.order && !this.order?.promoCode) {
				this.loadPromoCodes();
			}
		} catch (error) {
			console.error('Error in OrderContentComponent ngOnInit:', error);
		}

		try {
			this.repository.recommendationList$.pipe(debounceTime(500)).subscribe(recommendationArt => {
				try {
					if (this.venue && recommendationArt && recommendationArt.length > 0) {
						this.recommendationArticles = [];
						const categoryArticles = [].concat(
							...this.venue.articleCategories.filter(cat => !cat.hidden).map(it => it.articles)
						) as Article[];
						const categoryArticlesMap = new Map(categoryArticles.map(it => [it._id, it]));
						const orderArticles = this.order?.orderedArticles
							? new Map(this.order.orderedArticles.map(it => [it.article._id, it.article]))
							: new Map();
						recommendationArt.forEach(it => {
							if (it?.articles) {
								it.articles.forEach(art => {
									if (categoryArticlesMap.has(art)) {
										const article = categoryArticlesMap.get(art);
										if (
											article?.visible &&
											!article?.hidden &&
											!orderArticles.has(art) &&
											this.order &&
											isAvailable(article.availability, this.order.type, this.order.preorder.type)
										) {
											this.recommendationArticles.push(article);
										}
									}
								});
							}
						});
						console.log(this.recommendationArticles);
						this.startAutoPlaySlider();
					} else {
						this.recommendationArticles = [];
					}
				} catch (error) {
					console.error('Error processing recommendation articles:', error);
					this.recommendationArticles = [];
				}
			});
		} catch (error) {
			console.error('Error setting up recommendation subscription:', error);
		}
	}

	private async startAutoPlaySlider() {
		try {
			await sleep(1500);
			this.swiper.nativeElement?.swiper?.autoplay?.start();
			// console.log(this.swiper.nativeElement.swiper.update())
		} catch (e) {
			console.log(e, 'Problem with playing swiper...');
		}
	}

	onVenue() {
		super.onVenue();

		// If we have stored promo codes from when venue wasn't available, process them now
		if (this.storedPromoCodes && !this.customPromoCodeValue) {
			this.initValidAutoPromoCode(this.storedPromoCodes);
		}

		if (!this.extrasArticles) {
			this.initExtrasArticles();
		}

		this.validate();
		this.totalPrice();
	}

	initExtrasArticles() {
		this.extrasArticles = [];
		const unassigned = this.venue.articleCategories?.find(c => c.name.de === 'unassigned');
		if (!unassigned) {
			return;
		}
		unassigned.articles.forEach(a => {
			if (['Brot', 'Besteck'].includes(a.name.de)) {
				a.extra = true;
				const existingExtraArticleIndex = this.order.orderedArticles.findIndex(ag => ag.article._id === a._id);
				this.extrasArticles.push({ article: a, chosen: existingExtraArticleIndex > -1 });
			}
		});
	}

	async onOrder() {
		super.onOrder();
		if (this.order && this.order.orderedArticles && this.order.orderedArticles.length > 0) {
			this.analytics.orderHasProducts();
		}
		this.validate();
		// Fix: Always recalculate total when order changes (including when first item is added)
		if (this.order) {
			this.totalPrice();

			if (this.helloAgainService.isUserRedirectedFromHelloAgain) await this.openCheckoutModal();
		}
		// Re-evaluate automatic promo code when order type/flow changes (e.g. delivery -> pickup)
		if (this.venue && this.order && !this.order?.promoCode && !this.customPromoCodeValue && this.storedPromoCodes?.length) {
			this.initValidAutoPromoCode(this.storedPromoCodes);
		}

		// Auto-apply promo code when order changes
		if (this.venue && this.order && !this.order?.promoCode && this.customPromoCodeValue) {
			this.validateAndAutoApplyPromoCode();
		}
	}

	private async loadPromoCodes() {
		try {
			const automaticPromoCodes = (await Api.getPromoCodesBylinkedCustomerGroup())?.data as PromoCode[];
			this.storedPromoCodes = automaticPromoCodes ?? [];
			this.initValidAutoPromoCode(automaticPromoCodes);
		} catch (e) {
			console.log('Error while loading PromoCode');
		}
	}

	initValidAutoPromoCode(promoCodes: PromoCode[]) {
		// If venue is not available yet, store promo codes for later
		if (!this.venue) {
			this.storedPromoCodes = promoCodes;
			return;
		}

		// Use the repository service method to get valid promo code
		const previousPromoId = this.customPromoCodeValue?._id;
		this.customPromoCodeValue = this.repository.initValidAutoPromoCode(promoCodes, this.venue, this.order);
		const currentPromoId = this.customPromoCodeValue?._id;
		// If a different auto promo is selected, allow showing the confirmation popup again
		if (currentPromoId && currentPromoId !== previousPromoId) {
			this.customPromoCodeRemoved = false;
		}
	}

	async onAction(index: number, event: OrderListAction) {
		switch (event) {
			case OrderListAction.add:
				this.order.orderedArticles[index].quantity += 1;
				// Fix: Recalculate total price after adding items to keep cart in sync
				this.totalPrice();
				break;
			case OrderListAction.delete:
				if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
					const bogoArticleIndex = this.order.orderedArticles.findIndex(ag => ag.isPromo);
					const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
					const matchingBogoArticleIndices = this.order.orderedArticles
						.map((ag, agIndex) => {
							return ag.article._id === bogoArticle.article._id &&
								!ag.isPromo &&
								OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
									OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
								? agIndex
								: -1;
						})
						.filter(agIndex => agIndex !== -1);
					if (matchingBogoArticleIndices.find(bogoIndex => bogoIndex === index) !== undefined) {
						// article that should be removed is a possible parent of promoCode article
						if (matchingBogoArticleIndices.length === 1) {
							// only that article is possible parent of promoCode. If this article is removed the PromoCode and PromoArticle
							// should also be removed. Ask user.
							const bogoAlert = await this.alertCtrl.create({
								header: this.translateService.instant('remove_bogo_alert.header'),
								message: this.translateService.instant('remove_bogo_alert.message'),
								buttons: [
									{
										text: this.translateService.instant('remove_bogo_alert.button_remove'),
										handler: () => {
											this.order.orderedArticles[bogoArticleIndex].isPromo = false;
											this.order.promoCode = null;
											this.order.orderedArticles.splice(index, 1);
											// Fix: Recalculate total after removing promo items
											this.totalPrice();
											bogoAlert.dismiss();
										},
									},
									{
										text: this.translateService.instant('remove_bogo_alert.button_keep'),
										handler: () => {
											bogoAlert.dismiss();
										},
									},
								],
							});
							await bogoAlert.present();
							await bogoAlert.onDidDismiss();
							break;
						}
					}
				}
				this.order.orderedArticles.splice(index, 1);
				// Fix: Recalculate total price after deleting items
				this.totalPrice();
				break;
			case OrderListAction.note:
				this.noteArticle(index);
				break;
			case OrderListAction.edit:
				const modal = await this.modalCtrl.create({
					cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
					component: this.checkPageIfHaveGrid(JSON.parse(JSON.stringify(this.order.orderedArticles[index])))
						? ModalInfoHalfPizzaComponent
						: ModalInfoComponent,
					componentProps: {
						// copy article group
						articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
						recommend: false,
					},
					showBackdrop: true,
					backdropDismiss: true,
				});
				await modal.present();
				const response = await modal.onDidDismiss();
				if (response.data && response.data.articleGroup) {
					const promoAgIndex = this.order.orderedArticles.findIndex(oa => oa.isPromo);
					if (
						OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
						this.order.promoCode.type === PromoCodeType.BOGO &&
						this.order.orderedArticles[index].article._id === this.order.orderedArticles[promoAgIndex].article._id &&
						OrderUtils.bogoPrice(response.data.articleGroup, this.order.type, this.order.preorder.type) <
							OrderUtils.bogoPrice(this.order.orderedArticles[promoAgIndex], this.order.type, this.order.preorder.type)
					) {
						this.order.orderedArticles[promoAgIndex].isPromo = false;
						const newPromoAg = JSON.parse(JSON.stringify(response.data.articleGroup));
						newPromoAg.isPromo = true;
						this.order.orderedArticles.push(newPromoAg);
					}
					this.order.orderedArticles[index] = response.data.articleGroup;
					// Fix: Recalculate total after editing items
					this.totalPrice();
					this.repository.onOrderChange(this.order);
				}
				break;
			case OrderListAction.remove:
				if (this.order.orderedArticles[index].quantity > 1) {
					this.order.orderedArticles[index].quantity -= 1;
					// Fix: Recalculate total price after removing items to keep cart in sync
					this.totalPrice();
				} else {
					await this.onAction(index, OrderListAction.delete);
					return;
				}
				break;
		}
		this.checkPromoCodeIsExist(this.order);
		this.validateAndAutoApplyPromoCode();
		this.repository.onOrderChange(this.order);
	}

	private checkPromoCodeIsExist(order: Order): Order {
			if (order?.promoCode) {
				const promocode: PromoCode = order?.promoCode;
				if (promocode.type === PromoCodeType.CHEAPEST_FREE_ARTICLE || promocode.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE) {
					let amount = 0;
					const mappedArray: string[] = promocode.value?.articles;
					order.orderedArticles.forEach(orderArticleGroup => {
						if (mappedArray.includes(orderArticleGroup.article._id) || mappedArray.includes(orderArticleGroup.article.masterId)) {
							amount = amount + orderArticleGroup?.quantity;
						}
					});
				if (promocode?.value?.minQuantity) {
					let minValue = promocode?.value?.minQuantity;
					if (promocode.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE) {
						minValue = minValue + 1;
					}
					if (minValue > amount) {
						order = OrderUtils.removePromo(order);
					}
				}
			}
		}
		return order;
	}

	/**
	 * Validates and auto-applies promo codes on cart changes
	 * - Revalidates existing promo codes (venue match, MOV)
	 * - Auto-applies promo if valid and user hasn't manually overridden
	 */
	private async validateAndAutoApplyPromoCode(): Promise<void> {
		if (!this.venue || !this.order || !this.order.orderedArticles?.length) {
			return;
		}

		// If user manually deleted promo, don't re-apply
		if (this.customPromoCodeRemoved) {
			return;
		}

		// If promo exists, validate it's still valid
		if (this.order.promoCode) {
			const promo = this.order.promoCode;
			const isAvailableForOrderType = isAvailable(promo.availability, this.order.type, this.order.preorder.type);

			// Check venue match
			const isValidForVenue = promo.venues?.includes(this.venue._id);
			const isMasterCustomerGroupPromo = promo.isMaster === true && promo.customerGroup === this.venue.customerGroup;
			const isCustomerGroupPromo = (!promo.venues || promo.venues.length === 0) && promo.customerGroup === this.venue.customerGroup;

			if ((!isValidForVenue && !isMasterCustomerGroupPromo && !isCustomerGroupPromo) || !isAvailableForOrderType) {
				this.order = OrderUtils.removePromo(this.order);
				return;
			}
		} else if (this.customPromoCodeValue) {
			// No promo applied - try to auto-apply if venue-specific promo exists
			const promo = this.customPromoCodeValue;
			const isAvailableForOrderType = isAvailable(promo.availability, this.order.type, this.order.preorder.type);

			// Only auto-apply if promo is valid for this venue
			const isValidForVenue = promo.venues?.includes(this.venue._id);
			const isMasterCustomerGroupPromo = promo.isMaster === true && promo.customerGroup === this.venue.customerGroup;
			if ((!isValidForVenue && !isMasterCustomerGroupPromo) || !isAvailableForOrderType) {
				return;
			}

			// Handle FREE_ARTICLE types via special checker logic (popup etc)
			if (
				[PromoCodeType.FREE_ARTICLE, PromoCodeType.DEPENDENCY_FREEE_ARTICLE, PromoCodeType.MULTIPLE_FREE_ARTICLES].includes(
					promo.type
				)
			) {
				await this.checkIfCanApplyPromoCode(this.order);
				return;
			}

			// Apply promo directly (like addDefaultPromoCode pattern)
			try {
				if (promo.active !== false) {
					this.order = OrderUtils.applyPromo(this.translateService, this.repository._venue, this.order, promo, this.analytics);
					// Persist the change
					this.repository.onOrderChange(this.order);
				}
			} catch (e) {
				console.log('Auto promo apply failed:', e);
			}
		}
	}

	private async checkIfCanApplyPromoCode(order: Order) {
		if (
			order &&
			!order.promoCode &&
			this.customPromoCodeValue &&
			(this.customPromoCodeValue?.type === PromoCodeType.FREE_ARTICLE ||
				this.customPromoCodeValue?.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE ||
				this.customPromoCodeValue?.type === PromoCodeType.MULTIPLE_FREE_ARTICLES) &&
			this.order.orderedArticles.length &&
			!this.showCheckerDialog
		) {
			// For DEPENDENCY_FREEE_ARTICLE, validate minQuantity requirement first
			if (this.customPromoCodeValue?.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE) {
				const promoArticles = this.customPromoCodeValue?.value?.articles;
				const minQuantity = this.customPromoCodeValue?.value?.minQuantity;

				if (promoArticles && minQuantity) {
					const matchingArticleCount = order.orderedArticles
						.filter(ag => promoArticles.includes(ag.article._id) || promoArticles.includes(ag.article.masterId))
						.reduce((sum, ag) => sum + ag.quantity, 0);

					if (matchingArticleCount < minQuantity) {
						console.log('Promo code minQuantity not met:', matchingArticleCount, '<', minQuantity);
						return;
					}
				}
			}

			// Use repository service to validate promo code
			const validationResult = this.repository.checkPromoCodeValidity(this.customPromoCodeValue, this.venue, order);

			if (!validationResult.isValid) {
				console.log('Promo code validation failed:', validationResult.reason);
				return;
			}

			const productsRelatedToVenue = validationResult.eligibleArticles;

			// AUTO-ACCEPT PROMO: Confirmation dialog disabled - promo is automatically applied
			// TO RE-ENABLE: Uncomment the code below to show the "Ja, bitte" confirmation dialog to users

			this.showCheckerDialog = true;
			const askAboutApplyPromoCode = await InfoModalComponent.show(this.modalCtrl, {
				title: this.customPromoCodeValue.name,
				info: this.customPromoCodeValue.description[this.translateService.currentLang],
				mainButton: this.translateService.instant('promo_code.free_gelato.yes'),
				closeButton: this.translateService.instant('promo_code.free_gelato.no'),
				banner: this.customPromoCodeValue?.image?.original,
			});
			this.showCheckerDialog = false;
			if (!askAboutApplyPromoCode) {
				this.customPromoCodeRemoved = true;
				return;
			}

			// Apply promo code logic
			try {
				const orderCopy = JSON.parse(JSON.stringify(order));
				orderCopy.promoCode = this.customPromoCodeValue;
				orderCopy.userUid = this.repository.customer.uid;
				orderCopy.orderAt = null;
				orderCopy.customerRedemptionPromoCode = this.PROMO_GELATTO_FREE;
				const result = await Api.applyPromoCode(orderCopy);
				const promoCode = this.customPromoCodeValue;

				if (result.data && promoCode.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE) {
					const foundFree = result.data.orderedArticles.find(it => it.isPromo && it.freeArticle);
					const foundInList =
						promoCode.value &&
						(promoCode.value?.freeArticle === foundFree?.article?._id ||
							promoCode.value?.freeArticle === foundFree?.article?.masterId);
					if (foundInList) {
						let foundArticleInVenue: Article = null;
						this.venue.articleCategories.forEach(cat => {
							const foundProduct = cat.articles.find(
								art => art._id === foundFree?.article?._id || art?.masterId === foundFree?.article?._id
							);
							if (foundProduct) {
								foundArticleInVenue = foundProduct;
							}
						});
						if (foundArticleInVenue) {
							foundFree.article = foundArticleInVenue;
							order.orderedArticles.push(foundFree);
						}
					}
					const orderValue = OrderUtils.applyPromo(
						this.translateService,
						this.repository._venue,
						order,
						promoCode,
						this.analytics
					);
					this.repository.onOrderChange(orderValue);
				}

				if (result.data && promoCode.type === PromoCodeType.FREE_ARTICLE && promoCode?.value?.length) {
					try {
						const freeArticle =
							productsRelatedToVenue.length < 2
								? productsRelatedToVenue[0]
								: await SelectionProductFromFreeArticleComponent.show(this.modalCtrl, productsRelatedToVenue, this.order);
						if (!freeArticle) {
							this.customPromoCodeRemoved = true;
							return true;
						}

						try {
							const freeArticleGroup = new ArticleGroup();
							freeArticleGroup.article = freeArticle;
							freeArticleGroup.groups = defaultsToArticleOption(
								freeArticle,
								[],
								freeArticle.defaults,
								this.order?.type,
								this.order.preorder.type
							);
							freeArticleGroup.quantity = 1;
							freeArticleGroup.isPromo = true;
							freeArticleGroup.freeArticle = true;
							const orderValue = OrderUtils.applyPromo(
								this.translateService,
								this.repository._venue,
								order,
								promoCode,
								this.analytics,
								freeArticleGroup
							);

							this.repository.onOrderChange(orderValue);
						} catch (e) {
							console.log('e', e);
						}
					} catch (e) {
						return;
					}
				}

				// Handle MULTIPLE_FREE_ARTICLES - show selection popup or auto-add if only 1 article
				if (result.data && promoCode.type === PromoCodeType.MULTIPLE_FREE_ARTICLES) {
					try {
						// If there's only 1 unique article, automatically add max quantity
						if (productsRelatedToVenue.length === 1) {
							const singleArticle = productsRelatedToVenue[0];
							const maxQty = promoCode.value.maxQuantity || 1;
							const autoSelected: SelectedArticleWithQuantity[] = [
								{
									article: singleArticle,
									quantity: maxQty,
								},
							];
							await this.addMultipleFreeArticlesToOrder(autoSelected, promoCode, order);
						} else {
							// Multiple articles to choose from - show popup
							const selectedWithQuantity = await SelectionMultipleFreeArticlesComponent.show(
								this.modalCtrl,
								productsRelatedToVenue,
								this.order,
								promoCode.value.maxQuantity || 1,
								this.venue
							);

							if (selectedWithQuantity && selectedWithQuantity.length > 0) {
								await this.addMultipleFreeArticlesToOrder(selectedWithQuantity, promoCode, order);
							} else {
								this.customPromoCodeRemoved = true;
								return;
							}
						}
					} catch (e) {
						console.log('Error handling multiple free articles:', e);
						return;
					}
				}
			} catch (e) {}
		}
	}

	private async addMultipleFreeArticlesToOrder(
		selectedArticles: SelectedArticleWithQuantity[],
		promoCode: PromoCode,
		order: Order
	): Promise<void> {
		for (const selected of selectedArticles) {
			for (let i = 0; i < selected.quantity; i++) {
				let articleGroup = new ArticleGroup();
				articleGroup.article = selected.article;
				articleGroup.quantity = 1;
				articleGroup.isPromo = true;
				articleGroup.freeArticle = true;

				if (
					selected.article.groups.length > 0 &&
					selected.article.groups.find(it => it.requiredAmount > 0) &&
					!canSkipItemModal(selected.article)
				) {
					// Article has required groups - need to show modal for customization
					const customGroup = await this.showCustomGroupModal(selected.article);
					if (customGroup) {
						order = OrderUtils.applyPromo(
							this.translateService,
							this.repository._venue,
							order,
							promoCode,
							this.analytics,
							customGroup
						);
					}
				} else {
					// Article has no required groups - add directly
					articleGroup.groups = defaultsToArticleOption(
						selected.article,
						[],
						selected.article.defaults,
						order?.type,
						order.preorder.type
					);
					order = OrderUtils.applyPromo(
						this.translateService,
						this.repository._venue,
						order,
						promoCode,
						this.analytics,
						articleGroup
					);
				}
			}
		}
		// Update the order after all articles are added
		this.order = order;
		this.repository.onOrderChange(order);
	}

	private async showCustomGroupModal(article: Article): Promise<ArticleGroup | null> {
		const articleGroup = new ArticleGroup();
		articleGroup.article = article;
		articleGroup.groups = defaultsToArticleOption(article, [], article.defaults, this.order?.type, this.order.preorder.type);
		articleGroup.quantity = 1;
		articleGroup.isPromo = true;
		articleGroup.freeArticle = true;

		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
				noQuantity: true,
			},
			mode: 'ios',
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();

		if (response.data && response.data.articleGroup) {
			return response.data.articleGroup;
		}
		return null;
	}

	async openCheckoutModal() {
		this.validate();

		if (!this.isValid || this.loading) {
			return;
		}

		// Update order note with Relevo code before checkout
		this.updateOrderNoteWithRelevoCode();

		this.loading = true;

		if (this.recommendationArticles.length) {
			const result = await RecomendationArticleModalComponent.show(
				this.modalCtrl,
				this.recommendationArticles,
				this.order,
				this.totalNumber,
				this.venue
			);

			if (result?.data && result?.data?.length) {
				result.data.forEach(itemRecom => {
					const articleGroup = new ArticleGroup();
					articleGroup.article = itemRecom.article;
					articleGroup.groups.push(
						...defaultsToArticleOption(
							itemRecom.article,
							[],
							itemRecom.article.defaults,
							this.order?.type,
							this.order.preorder.type
						)
					);
					articleGroup.quantity = itemRecom.quantity;
					OrderUtils.addToOrder(this.order, articleGroup, this.analytics);

					// Track add to cart with Tracify
					this.tracifyService.trackAddToCart();

					this.repository.onOrderChange(this.order);
				});
				this.recommendationArticles = [];
				return (this.loading = false);
			}
		}

		if (AppComponent.largeScreen) {
			this.openCheckout.emit();
		}
		const result = await CheckoutModalComponent.show(this.modalCtrl, this.analytics, this.order, this.tip);
		if (result.data === undefined) {
			this.loading = false;
			return;
		}
		this.order.orderAt = result.data.orderAt;
		this.order.preorder = result.data.preorder;

		try {
			const resultData = this.checkBrowserData();
			this.order.clientMeta = resultData;
		} catch (e) {}

		this.tip = result.data.tip;

		// Re-apply Relevo code before sending order (it might have been lost during modal flow)
		this.updateOrderNoteWithRelevoCode();

		this.repository.onOrderChange(this.order);

		try {
			await this.repository.createOrderWithPayment(
				this.modalCtrl,
				this.translateService,
				this.order,
				this.tip,
				loading => (this.loading = loading),
				this.snackbarCtrl,
				null,
				null,
				result.data.paymentType === checkoutPaymentType.CASH,
				result.data.paymentType === checkoutPaymentType.LATER
			);
		} catch (e) {
			console.log(JSON.parse(JSON.stringify(e)));
		}
	}

	handleExtraArticlesToggle(ex: { article: Article; chosen: boolean }) {
		if (ex.chosen) {
			const articleGroup = new ArticleGroup();
			articleGroup.article = ex.article;
			articleGroup.groups.push(
				...defaultsToArticleOption(ex.article, [], ex.article.defaults, this.order?.type, this.order.preorder.type)
			);
			articleGroup.quantity = 1;
			OrderUtils.addToOrder(this.order, articleGroup, this.analytics);

			// Track add to cart with Tracify
			this.tracifyService.trackAddToCart();

			this.repository.onOrderChange(this.order);
		} else {
			const articleIndex = this.order.orderedArticles.findIndex(ag => ag.article._id === ex.article._id);
			this.onAction(articleIndex, OrderListAction.delete);
		}
	}

	validate() {
		if (!this.order || !this.venue || !this.order.preorder) {
			this.isValid = false;
			return;
		}

		const result = OrderUtils.validateOrder(this.venue, this.order);
		// Fix: Check if promoCode exists before accessing its type to prevent crashes
		if (result.movDifference < 0 && this.order.promoCode?.type === PromoCodeType.FREE_ARTICLE) {
			OrderUtils.removePromo(this.order);
			this.customPromoCodeRemoved = true;
			result.valid = true;
		} else {
			this.differenceToMvo = result.movDifference;
		}

		const orderFSK = maxFskOfOrder(this.order);
		this.orderFSK = orderFSK;

		if (orderFSK > 0) {
			this.showAgeVefiried = true;
			if (!this.ageVerified) {
				this.isValid = false;
				return;
			}
		} else {
			this.showAgeVefiried = false;
		}

		// Relevo code validation when cart has articles with relevo tag
		if (this.hasRelevoArticle() && !this.validateRelevoCode()) {
			this.isValid = false;
			return;
		}

		this.isValid = result.valid;
	}

	// Relevo code validation
	validateRelevoCode(): boolean {
		// Only validate if there are relevo articles in cart
		if (!this.hasRelevoArticle()) {
			this.relevoCodeError = '';
			return true;
		}

		// Reset error
		this.relevoCodeError = '';

		if (!this.relevoCode || this.relevoCode.trim().length === 0) {
			this.relevoCodeError = this.translateService.instant('packaging.validation_error');
			return false;
		}

		const trimmedCode = this.relevoCode.trim().toUpperCase();

		// Check if exactly 6 characters
		if (trimmedCode.length !== 6) {
			this.relevoCodeError = this.translateService.instant('packaging.validation_error');
			return false;
		}

		// Check if alphanumeric (only letters and numbers)
		if (!/^[A-Z0-9]{6}$/.test(trimmedCode)) {
			this.relevoCodeError = this.translateService.instant('packaging.validation_error');
			return false;
		}

		// Update the code with uppercase trimmed version
		this.relevoCode = trimmedCode;
		return true;
	}

	onRelevoCodeChange() {
		this.validateRelevoCode();
		this.validate();
	}

	hasRelevoArticle(): boolean {
		if (!this.order || !this.order.orderedArticles) {
			return false;
		}

		return this.order.orderedArticles.some(articleGroup => {
			// Check main article tags
			if (articleGroup.article.tags?.some(tag => tag.identifier === this.RELEVO_TAG)) {
				return true;
			}

			// Check all groups/options within the article for relevo tag
			if (articleGroup.groups && articleGroup.groups.length > 0) {
				return articleGroup.groups.some(group => {
					return group.article?.tags?.some(tag => tag.identifier === this.RELEVO_TAG);
				});
			}

			return false;
		});
	}

	updateOrderNoteWithRelevoCode() {
		if (!this.order) {
			return;
		}

		// Store Relevo code in order.relevoCode - it will be appended to note in Converter.ts when sending to backend
		if (this.hasRelevoArticle() && this.relevoCode && this.relevoCode.trim().length > 0) {
			this.order.relevoCode = this.relevoCode.trim().toUpperCase();
		} else {
			this.order.relevoCode = undefined;
		}
	}

	amountOfPoints() {
		return OrderUtils.orderTotalPrice(this.order, true, true) + this.tip;
	}

	mapGroup(articleGroup: ArticleGroup) {
		if (!this.venue || !this.order) {
			return articleGroup;
		}
		if (articleGroup.isHalfPizza) {
			const foundArticle = this.venue.articleCategories
				.map(it => {
					if (it.visible) {
						const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

						return foundArticle ?? null;
					} else {
						return null;
					}
				})
				.filter(it => !!it);
			if (foundArticle.length === 1) {
				const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
				test.article = JSON.parse(JSON.stringify(foundArticle[0]));
				return test;
			}
			return articleGroup;
		}
		return articleGroup;
	}

	totalPrice() {
		// Fix: Calculate total even when venue data isn't loaded yet (important for delivery orders)
		if (this.order?.orderedArticles) {
			// Special handling for half-pizza when venue data is available
			if (this.venue) {
				const foundArticleIndex = this.order.orderedArticles.findIndex(it => it.isHalfPizza);
				if (foundArticleIndex >= 0) {
					const foundArticle = this.venue.articleCategories
						.map(it => it.articles.find(ar => ar.tags?.find(tag => tag.identifier == 'appliesMostExpensive')))
						.filter(it => !!it);

					if (foundArticle.length > 0) {
						let mappedOrder = JSON.parse(JSON.stringify(this.order)) as Order;
						mappedOrder.orderedArticles = mappedOrder.orderedArticles.map(it => {
							if (it.isHalfPizza) {
								it.article = foundArticle[0];
							}
							return it;
						});
						const total = OrderUtils.orderTotalPrice(mappedOrder, true, true) + (this.tip || 0);
						// Fix: Provide default currency if not set
						this.totalPriceValue = numberToCurrency(total, this.order.currency || 'EUR');
						this.totalNumber = +total.toFixed(2);
						return;
					}
				}
			}
			// Default calculation - works even without venue data loaded
			const total = OrderUtils.orderTotalPrice(this.order, true, true) + (this.tip || 0);
			// Fix: Provide default currency if not set to prevent crashes
			this.totalPriceValue = numberToCurrency(total, this.order.currency || 'EUR');
			this.totalNumber = +total.toFixed(2);
		}
	}

	replace(index: number, article: Article, options: ArticleOption[]) {
		this.order.orderedArticles[index].quantity = 1;
		this.order.orderedArticles[index].article = article;
		this.order.orderedArticles[index].groups = options;
	}

	onPromoApplied(order: Order) {
		this.promoError = null;
		this.repository.onOrderChange(order);
	}

	onDeletePromo(order: Order) {
		this.promoError = null;
		// Set flag BEFORE order change to prevent auto re-apply
		if (this.customPromoCodeValue) {
			this.customPromoCodeRemoved = true;
		}
		this.repository.onOrderChange(order);
	}

	onPromoCodeError(error: string) {
		if (!error) {
			// error just resetting error no error happened
			return;
		}
		// Promo error
		this.snackbarCtrl.open(error, null, { duration: 2000 });
		this.repository.onOrderChange(OrderUtils.removePromo(this.order));

		this.promoError = error;
	}

	async backToMenu() {
		await this.navigationService.menu();
	}

	async noteArticle(index: number) {
		const modal = await this.modalCtrl.create({
			cssClass: 'short-info-modal auto-height',
			component: NoteArticleModalComponent,
			componentProps: {
				// copy article group
				articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
				recommend: false,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response?.data || response.data === '') {
			this.order.orderedArticles[index].note = response?.data;
		}
	}

	handleChangeRadio(event: { detail: { value: string } }) {
		console.log(event.detail.value);
	}

	login() {
		this.navigationService.signIn();
	}

	signUp() {
		this.navigationService.signUp();
	}

	checkPageIfHaveGrid(articleGroup: ArticleGroup) {
		console.log(articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')));
		return (
			articleGroup.article.groups.length > 0 &&
			articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')).length > 0
		);
		// return articleGroup.article.tags.find(it => it.identifier == 'half_pizza');
	}

	identify(index, item) {
		return item?.group;
	}

	changeAgeVerification() {
		setTimeout(() => this.validate());
	}

	checkBrowserData() {
		try {
			const userAgent = navigator.userAgent;
			const platform = 'web';
			const browser = this.getBrowserInfo(userAgent);
			const osVersion = this.getOSVersion(userAgent);

			return {
				platform,
				appVersion: environment.version,
				osVersion,
				browser,
				device: userAgent,
			};
		} catch (e) {}
	}

	getBrowserInfo(userAgent: string): string {
		if (userAgent.includes('Chrome')) {
			return 'Chrome';
		} else if (userAgent.includes('Firefox')) {
			return 'Firefox';
		} else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
			return 'Safari';
		} else if (userAgent.includes('Edg')) {
			return 'Edge';
		}
		return 'Unknown';
	}

	getOSVersion(userAgent: string): string {
		const osMatches = [
			{ name: 'Windows', regex: /Windows NT ([\d.]+)/ },
			{ name: 'macOS', regex: /Mac OS X ([\d_]+)/ },
			{ name: 'iOS', regex: /iPhone OS ([\d_]+)/ },
			{ name: 'iPadOS', regex: /iPad; CPU OS ([\d_]+)/ },
			{ name: 'Android', regex: /Android ([\d.]+)/ },
			{ name: 'Linux', regex: /Linux ([a-z\d.]+)/i },
			{ name: 'Linux', regex: /Linux/i },
			{ name: 'Ubuntu', regex: /Ubuntu ([\d.]+)/i },
			{ name: 'Fedora', regex: /Fedora/i },
			{ name: 'Debian', regex: /Debian/i },
			{ name: 'Arch Linux', regex: /Arch Linux/i },
			{ name: 'CentOS', regex: /CentOS/i },
			{ name: 'Red Hat', regex: /Red Hat/i },
			{ name: 'SuSE', regex: /SUSE/i },
			{ name: 'Chrome OS', regex: /CrOS ([\d.]+)/i },
			{ name: 'Windows Phone', regex: /Windows Phone ([\d.]+)/i },
			{ name: 'KaiOS', regex: /KaiOS ([\d.]+)/i },
			{ name: 'FreeBSD', regex: /FreeBSD/i },
			{ name: 'OpenBSD', regex: /OpenBSD/i },
			{ name: 'NetBSD', regex: /NetBSD/i },
		];

		for (const os of osMatches) {
			const match = userAgent.match(os.regex);
			if (match) {
				const version = match[1] ? ` ${match[1].replace(/_/g, '.')}` : '';
				return `${os.name}${version}`;
			}
		}

		return 'Unknown';
	}

	async customModalGroup(
		item: Article,
		category: ArticleCategory,
		addRecomendations: boolean = false,
		isPromo: boolean = false,
		isFree: boolean = false
	): Promise<ArticleGroup | null> {
		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;
		articleGroup.isPromo = true;
		articleGroup.freeArticle = true;
		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
				noQuantity: true,
			},
			mode: 'ios',
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();

		if (response.data && response.data.articleGroup) {
			return response.data.articleGroup;
		}
		return null;
	}

	async openModal(item: Article) {
		console.log(item);
		if (this.loading) {
			return;
		}

		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;

		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
				noQuantity: true,
			},
			mode: 'ios',
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response.data && response.data.articleGroup) {
			OrderUtils.addToOrder(this.order, response.data.articleGroup, this.analytics);

			// Track add to cart with Tracify
			this.tracifyService.trackAddToCart();

			this.repository.onOrderChange(this.order);
		}
	}

	checkPfandTag(article: Article) {
		if (article.tags?.length === 0) {
			return '';
		}
		const deposit25 = article.tags.find(it => it.identifier === 'deposit25') ? 'deposit25' : '';
		const deposit15 = article.tags.find(it => it.identifier === 'deposit15') ? 'deposit15' : '';

		return deposit15 || deposit25;
	}
}
